import fileFormatCsvIcon from '@/pages/aigc/assets/svg/file-format-csv.svg';
import fileFormatExcelIcon from '@/pages/aigc/assets/svg/excel.svg';
import fileFormatHtmlIcon from '@/pages/aigc/assets/svg/ai-gallery-html-file-icon.svg';
import fileFormatImageIcon from '@/pages/aigc/assets/svg/agent-document-magic-poster.svg';
import fileFormatMarkdownIcon from '@/pages/aigc/assets/svg/file-format-markdown.svg';
import fileFormatPdfIcon from '@/pages/aigc/assets/svg/file-format-pdf.svg';
import fileFormatPowerpointIcon from '@/pages/aigc/assets/svg/file-format-powerpoint.svg';
import fileFormatTxtIcon from '@/pages/aigc/assets/svg/file-format-txt.svg';
import fileFormatWordIcon from '@/pages/aigc/assets/svg/file-format-word.svg';
import fileFormatZipIcon from '@/pages/aigc/assets/svg/file-format-zip.svg';

export type TFileFormatIconType =
  | 'html'
  | 'excel'
  | 'csv'
  | 'word'
  | 'txt'
  | 'zip'
  | 'markdown'
  | 'pdf'
  | 'powerpoint'
  | 'image'
  | 'default';

export const FILE_FORMAT_ICON_MAP: Record<TFileFormatIconType, string> = {
  html: fileFormatHtmlIcon,
  excel: fileFormatExcelIcon,
  csv: fileFormatCsvIcon,
  word: fileFormatWordIcon,
  txt: fileFormatTxtIcon,
  zip: fileFormatZipIcon,
  markdown: fileFormatMarkdownIcon,
  pdf: fileFormatPdfIcon,
  powerpoint: fileFormatPowerpointIcon,
  image: fileFormatImageIcon,
  default: fileFormatMarkdownIcon,
};

/** 按文件后缀映射图标类型 */
export const getFileFormatIconType = (ext: string): TFileFormatIconType => {
  switch ((ext || '').toLowerCase()) {
    case 'html':
    case 'htm':
      return 'html';
    case 'xls':
    case 'xlsx':
      return 'excel';
    case 'csv':
      return 'csv';
    case 'doc':
    case 'docx':
      return 'word';
    case 'txt':
      return 'txt';
    case 'zip':
      return 'zip';
    case 'md':
    case 'markdown':
      return 'markdown';
    case 'pdf':
      return 'pdf';
    case 'ppt':
    case 'pptx':
      return 'powerpoint';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'webp':
    case 'bmp':
      return 'image';
    default:
      return 'default';
  }
};

/** 按文件后缀返回对应图标 URL */
export const getFileFormatIcon = (ext: string): string =>
  FILE_FORMAT_ICON_MAP[getFileFormatIconType(ext)];
